import { type RootState } from "app";

import { ProcoreToolMode } from "./types";

export const selectProcoreUx = (state: RootState) => state.procoreUx;
export const selectActiveToolMode = (state: RootState) => state.procoreUx.activeToolMode;

/**
 * Whether the user is in a mode that demands precise work on the model itself
 * (placing section planes or measurement points), as opposed to just navigating.
 *
 * Mobile hides its navigation overlays in these modes to free up the small
 * screen, so the set of modes is enumerated explicitly rather than derived from
 * `!== Default`: modes added later should opt in deliberately.
 */
export const selectIsFocusedToolMode = (state: RootState) =>
    state.procoreUx.activeToolMode === ProcoreToolMode.Measure ||
    state.procoreUx.activeToolMode === ProcoreToolMode.Section;
